//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import BackendServices from "@/services/backend-services.js";
import moment from "moment";
import { required } from "@/utils/validations.js";
import { noValidation } from "@/utils/validations.js";
import { validateDate } from "@/utils/validations.js";

const EMPTY_LINE = {
  route_name: null,
  code: null,
  name: null,
  ranking: null,
  seller: null,
  frequency: null,
};

export default {
  name: "RoutesTab",
  props: ["value"],
  components: {},
  mounted: function () {
    this.employeesLoading = true;
    this.storesLoading = true;
    BackendServices.getSalesforceRoutePeriods().then((response) => {
      this.periodList = response.data;
    });
    BackendServices.getProductHierarchyLevels().then((response) => {
      this.areaLevelList = response.data;
    });
    BackendServices.getSalesforceEmployees({ page: 1, rowsPerPage: 1000 }).then(
      (response) => {
        this.sellerList = response.data;
        this.employeesLoading = false;
      }
    );
    BackendServices.getStores({ page: 1, rowsPerPage: 1000 }).then(
      (response) => {
        this.storeList = response.data;
        this.storesLoading = false;
      }
    );

    this.formOpen = new Array(this.value.store_visits.length).fill(false);
    this.validateData();
  },
  data: function () {
    return {
      moment,
      validForm: false,
      employeesLoading: false,
      storesLoading: false,
      businessAreaLevelId: null,
      tab: "general",
      formOpen: [],
      periodList: [],
      areaLevelList: [],
      areaList: [],
      sellerList: [],
      storeList: [],
      popupForm: EMPTY_LINE,
      newRegistry: true,
    };
  },
  methods: {
    required,
    noValidation,
    validateDate,
    deleteRecord: async function () {
      let response = await BackendServices.deleteSalesforceRoute(this.value);
      this.$emit("change-tab", response.status);
    },
    EndDateValid(val) {
      if (val) {
        return val > this.value.start_date || "Data inválida";
      }
    },
    endDateRestriction(val) {
      return val > this.value.start_date;
    },
    validateData: function () {
      this.$refs.form.validate().then((success) => {
        if (success) {
          this.validForm = true;
          this.$emit("form-valid", this.validForm);
        } else {
          this.validForm = false;
          this.$emit("form-invalid", this.validForm);
        }
      });
    },
    fetchBusinessAreas() {
      this.value.product_hierarchy_ids = [];
      BackendServices.getProductHierarchyLevelElements(
        this.businessAreaLevelId
      ).then((response) => {
        this.areaList = response.data;
      });
      this.updateData();
    },
    addBusiness(event) {
      this.value.product_hierarchy_ids.push(event.value);
      this.updateData();
    },
    removeBusiness(event) {
      this.value.product_hierarchy_ids.splice(
        this.value.product_hierarchy_ids.indexOf(event.value),
        1
      );
      this.updateData();
    },
    addLine: function () {
      this.value.store_visits.push(EMPTY_LINE);
      this.formOpen.push(false);
      this.openForm(this.value.store_visits.length - 1);
      this.isNew = true;
    },
    removeLine: function (index) {
      this.value.store_visits.splice(index, 1);
      this.updateData();
    },
    deleteNewLine: function () {
      if (this.isNew) {
        this.value.store_visits.splice(this.value.store_visits.length - 1, 1);
        this.isNew = false;
      }
    },
    findEmployeesByName: function (search) {
      return BackendServices.getSalesforceHierarchyLevelElements().then(
        (hierarchyResult) => {
          return BackendServices.getSalesforceEmployees(
            { page: 1, rowsPerPage: 1000 },
            search && search.length ? search : null
          ).then((result) => {
            this.sellerList = result.data.filter(
              (item) =>
                item.role_id ===
                hierarchyResult.data.filter((item) => !item.child_ids.length)[0]
                  .id
            );
          });
        }
      );
    },
    filterEmployeesByName: function (name, update) {
      update(async () => {
        await this.findEmployeesByName(null);
        this.sellerList = this.sellerList.filter(
          (seller) => seller.name.toLowerCase().indexOf(name.toLowerCase()) >= 0
        );
      });
    },
    openForm: function (index) {
      this.formOpen[index] = true;
      this.popupForm = JSON.parse(
        JSON.stringify(this.value.store_visits[index])
      );
    },
    submitForm: function (index) {
      this.formOpen[index] = false;
      this.value.store_visits.splice(
        index,
        1,
        JSON.parse(JSON.stringify(this.popupForm))
      );
      this.updateValue();
      this.isNew = false;
    },
    updateData() {
      this.$emit("value", this.value);
    },
  },
};
